import React from "react";
type GuaranteeSealProps = {
  days: number;
  className?: string;
};
const SERIF = '"Playfair Display", Georgia, serif';
const SANS = '"Inter", system-ui, sans-serif';
export function GuaranteeSeal({
  days,
  className = ""
}: GuaranteeSealProps) {
  const rosette = buildRosette(100, 100, 98, 91, 36);
  const ringText = "GARANTÍA DE SATISFACCIÓN • REEMBOLSO DEL 100% • ";
  return <svg viewBox="0 0 200 200" role="img" aria-label={`Sello de garantía de ${days} días`} className={className} data-id="element-115" data-mp="2wh565pi0248i">
      <defs data-id="element-116" data-mp="31fgetwwk68p5">
        <path id="seal-text-path" d="M100,100 m-67,0 a67,67 0 1,1 134,0 a67,67 0 1,1 -134,0" data-id="element-117" data-mp="31f6x0wlo37uj" />
      </defs>

      {/* Borde festoneado */}
      <polygon points={rosette} fill="#D9822B" data-id="element-118" data-mp="2sf1ryt3y4ljj" />
      <circle cx="100" cy="100" r="86" fill="#28180F" data-id="element-119" data-mp="2sdqnss6l9brw" />
      <circle cx="100" cy="100" r="81" fill="none" stroke="#E59A4F" strokeWidth="1.2" data-id="element-120" data-mp="1c0ilexkwhtxk" />

      {/* Texto circular */}
      <text fill="#F0B97E" fontFamily={SANS} fontSize="9" fontWeight="700" letterSpacing="1.5" data-id="element-121" data-mp="1h16avethe2po">
        <textPath href="#seal-text-path" textLength="418" lengthAdjust="spacing" data-id="element-122" data-mp="2eqleodcc2564">
          {ringText}
        </textPath>
      </text>

      {/* Centro */}
      <circle cx="100" cy="100" r="55" fill="#1C110B" stroke="#E59A4F" strokeWidth="1.2" data-id="element-123" data-mp="29stl7ew1iazt" />
      <circle cx="100" cy="100" r="50" fill="none" stroke="#E59A4F" strokeOpacity="0.35" strokeWidth="0.8" data-id="element-124" data-mp="2oldc9h5x0s0w" />

      <text x="100" y="114" textAnchor="middle" fill="#FCF8F2" fontFamily={SERIF} fontSize="54" fontWeight="600" data-id="element-125" data-mp="2xoeidhus6j4k">
        {days}
      </text>
      <text x="100" y="131" textAnchor="middle" fill="#F0B97E" fontFamily={SANS} fontSize="9.5" fontWeight="700" letterSpacing="3" data-id="element-126" data-mp="2soa1vrtvhoec">
        DÍAS
      </text>
      <path d="M84 70 h32" stroke="#E59A4F" strokeWidth="1" strokeOpacity="0.6" data-id="element-127" data-mp="32f4mysvduhy7" />
    </svg>;
}
function buildRosette(cx: number, cy: number, outer: number, inner: number, points: number): string {
  const coords: string[] = [];
  const total = points * 2;
  for (let i = 0; i < total; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const angle = Math.PI * 2 * i / total - Math.PI / 2;
    coords.push(`${(cx + r * Math.cos(angle)).toFixed(2)},${(cy + r * Math.sin(angle)).toFixed(2)}`);
  }
  return coords.join(" ");
}